import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ComponentsModule } from '../shared/components/components.module';
import { PipesModule } from "../shared/pipes/pipes.module";

import { DialectRoutingModule } from './dialect-routing.module';

import { DialectComponent } from './dialect.component';
import { DialectItemHeadComponent } from "./dialect-item-head/dialect-item-head.component";
import { DialectItemBodyComponent } from "./dialect-item-body/dialect-item-body.component";
import { DialectMenuComponent } from './dialect-menu/dialect-menu.component';
import { DialectRegionComponent } from './dialect-region/dialect-region.component';
import { DialectRegionMapComponent } from './dialect-region-map/dialect-region-map.component';
import { DialectStoryComponent } from './dialect-story/dialect-story.component';
import { MovieListComponent } from './movie-list/movie-list.component';
import { RegionMenuComponent } from './region-menu/region-menu.component';
import { DialectListPageComponent } from './dialect-list-page/dialect-list-page.component';


@NgModule({
    declarations: [
        DialectComponent,
        DialectItemHeadComponent,
        DialectItemBodyComponent,
        DialectMenuComponent,
        DialectRegionComponent,
        DialectRegionMapComponent,
        DialectStoryComponent,
        MovieListComponent,
        RegionMenuComponent,
        DialectListPageComponent,
    ],
    exports: [
        DialectRegionMapComponent
    ],
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        RouterModule,
        PipesModule,
        ComponentsModule,
        DialectRoutingModule,
    ]
})
export class DialectModule { }
